module.exports = {
  "country": "RU",
  "artist": "Sergey Lazarev",
  "song": "You are the only One",
  "year": "2016",
  "place": "3",
  "spotify": "7ANprWfKB8UoNggroXtfUv"
};